const hero = document.getElementById('hero');
const heroMobile = document.getElementById('heroMobile');

// 1) Esperamos a que la foto de fondo (banner) termine de cargar de verdad.
// 2) Recién ahí arrancan la cuenta y aparecen los stickers en cascada.
// 3) Cuando terminan de entrar, aparecen los botones.

const STICKER_START_DELAY = 700;   // ms antes de que empiecen a aparecer los stickers, DESPUÉS de que cargó la foto
const STICKER_ANIM_DURATION = 550; // debe coincidir con la duración de popIn en style.css
const LAST_STICKER_DELAY = 1750;   // el valor --d del último sticker, en ms (1.75s)

const HERO_BG_DESKTOP = 'https://cdn.shopify.com/s/files/1/0824/9851/9351/files/remark-hero-desktop.png?v=1786116176';
const HERO_BG_MOBILE  = 'https://cdn.shopify.com/s/files/1/0824/9851/9351/files/remark-banner-celula.png?v=1786075506';

function preloadImage(url){
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve; // si falla, no bloqueamos la animación para siempre
    img.src = url;
  });
}

function startHeroAnimation(heroEl){
  if(!heroEl) return;
  setTimeout(() => {
    heroEl.classList.add('stickers-on');
  }, STICKER_START_DELAY);

  setTimeout(() => {
    heroEl.classList.add('ctas-on');
  }, STICKER_START_DELAY + LAST_STICKER_DELAY + STICKER_ANIM_DURATION);
}

// Precargamos la foto de fondo real (la misma que usa el CSS) y solo
// arrancamos la animación de ESE hero cuando esa foto ya está lista.
preloadImage(HERO_BG_DESKTOP).then(() => startHeroAnimation(hero));
preloadImage(HERO_BG_MOBILE).then(() => startHeroAnimation(heroMobile));


/* ---------- Sección 3: filas de productos "justificadas" ----------
   Cada fila ajusta su altura para que la suma de los anchos naturales
   de las fotos llene el 100% del ancho, sin recortar ninguna imagen
   (misma técnica que usan las galerías tipo Google Fotos). */

function fitRow(row){
  const imgs = Array.from(row.querySelectorAll('img'));
  if(!imgs.length) return;

  const allLoaded = imgs.every(img => img.complete && img.naturalWidth > 0);
  if(!allLoaded) return;

  const gap = parseFloat(getComputedStyle(row).gap) || 0;
  const totalGap = gap * (imgs.length - 1);
  const containerWidth = row.clientWidth;
  const availableWidth = containerWidth - totalGap;

  const sumRatio = imgs.reduce((sum, img) => sum + (img.naturalWidth / img.naturalHeight), 0);
  if(sumRatio <= 0) return;

  const height = availableWidth / sumRatio;
  row.style.height = height + 'px';
}

function fitAllRows(){
  document.querySelectorAll('.products-row').forEach(row => {
    const imgs = Array.from(row.querySelectorAll('img'));
    let pending = imgs.filter(img => !(img.complete && img.naturalWidth > 0)).length;

    if(pending === 0){
      fitRow(row);
      return;
    }
    imgs.forEach(img => {
      if(!(img.complete && img.naturalWidth > 0)){
        img.addEventListener('load', () => {
          pending--;
          if(pending === 0) fitRow(row);
        });
      }
    });
  });
}

fitAllRows();
window.addEventListener('resize', () => {
  document.querySelectorAll('.products-row').forEach(fitRow);
});


/* ---------- Sección 4: animación del texto "make it yours." ----------
   Se dispara cuando la sección entra en pantalla al hacer scroll. */

const quoteBanner = document.getElementById('quoteBanner');

if(quoteBanner){
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        quoteBanner.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  observer.observe(quoteBanner);
}

const quoteBannerMobile = document.getElementById('quoteBannerMobile');

if(quoteBannerMobile){
  const observerM = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        quoteBannerMobile.classList.add('in-view');
        observerM.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  observerM.observe(quoteBannerMobile);
}


/* ---------- Sección 6: animación del banner de accesorios ---------- */

const accessoriesBanner = document.getElementById('accessoriesBanner');

if(accessoriesBanner){
  const accObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        accessoriesBanner.classList.add('in-view');
        accObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  accObserver.observe(accessoriesBanner);
}

const accessoriesBannerMobile = document.getElementById('accessoriesBannerMobile');

if(accessoriesBannerMobile){
  const accObserverM = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        accessoriesBannerMobile.classList.add('in-view');
        accObserverM.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  accObserverM.observe(accessoriesBannerMobile);
}


/* ---------- Sección 7: carrusel de opiniones de clientes ---------- */

const testimonials = [
  { quote: '“La mejor funda que he tenido, súper resistente y muy yo”', author: '-Renata Olivas' },
  { quote: '“Pude agregar todos los stickers que quería sin costo extra”', author: '-Alexa Gómez' },
  { quote: '“Al fin no me tengo que conformar con las fundas genéricas”', author: '-Luisa Corral' },
  { quote: '“La mejor relación calidad precio y el servicio es increíble”', author: '-Amanda Gtz' },
  { quote: '“Les mande el diseño que quería con mejoras y lo hicieron!”', author: '-Amanda Gtz' },
];

const testimonialQuote = document.getElementById('testimonialQuote');
const testimonialAuthor = document.getElementById('testimonialAuthor');
const testimonialNext = document.getElementById('testimonialNext');

let testimonialIndex = 0;
let testimonialTimer = null;

function showTestimonial(i){
  const content = document.querySelector('.testimonial-content');
  content.style.opacity = 0;
  content.style.transform = 'translateY(10px)';
  setTimeout(() => {
    testimonialIndex = i;
    testimonialQuote.textContent = testimonials[testimonialIndex].quote;
    testimonialAuthor.textContent = testimonials[testimonialIndex].author;
    content.style.transform = 'translateY(-10px)';
    requestAnimationFrame(() => {
      content.style.opacity = 1;
      content.style.transform = 'translateY(0)';
    });
  }, 400);
}

function nextTestimonial(){
  showTestimonial((testimonialIndex + 1) % testimonials.length);
}

function restartTestimonialTimer(){
  if(testimonialTimer) clearInterval(testimonialTimer);
  testimonialTimer = setInterval(nextTestimonial, 2000);
}

if(testimonialNext){
  testimonialNext.addEventListener('click', () => {
    nextTestimonial();
    restartTestimonialTimer();
  });
  restartTestimonialTimer();
}


/* ---------- Animación genérica al hacer scroll ----------
   Cualquier elemento con la clase "reveal" aparece con un
   fundido + deslizamiento hacia arriba cuando entra en pantalla. */

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if(entry.isIntersecting){
      entry.target.classList.add('revealed');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));